import React from "react";
import { useEffect, useState } from "react";
import { GetSalesByPerson, PartyPaymentDue, PostPaymentDue } from "../../util/APIUtils";
import { useMemo } from "react";
import { LoadingOverlay } from "../../util/Helpers";
import PartyDueBody from "./PartyDueBody";

export default function PartyDue() {
  const [values, setValues] = useState({ name: "test" });
  const [trans, setTrans] = useState([]);
  const [block, setBlock] = useState(false);

  useEffect(() => {
    loadReqData();
  }, []);

  const loadReqData = () => {
    setBlock(true);
    PartyPaymentDue(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };


  const memoizedTrans = useMemo(() => trans, [trans]);
  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <PartyDueBody
        data={memoizedTrans}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PartyDue.js